import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";

import Manager from './Components/Manager/Manager'
import FourOhFour from './Components/FourOhFour/FourOhFour'
import LandingPage from './Components/Landing/LandingPage'
import BadUUID from './Components/BadUUID/BadUUID'
import BreakoutCarrier from './Components/BreakoutCarrier/BreakoutCarrier';
import QuickSchedule from './Components/QuickSchedule/QuickSchedule';
import { UserPermissionsProvider } from './context/UserPermissionsProvider';

import './App.css';

import withClearCache from "./ClearCache";

const ClearCacheComponent = withClearCache(MainApp);

function App() {
  return <ClearCacheComponent />;
}

function MainApp() {
  return (
    <Router>
      <UserPermissionsProvider>
        <div className="App">
          <Switch>
            <Route path="/manager/:locationId/:UUID/" component={Manager} />
            <Route path="/carrier/:driverCode/" component={BreakoutCarrier} />
            <Route path="/quickschedule/:driverCode/" component={QuickSchedule} />
            <Route exact path="/baduuid/" component={BadUUID} />
            <Route exact path="/" component={LandingPage} />
            <Route component={FourOhFour} />
          </Switch>
        </div >
      </UserPermissionsProvider>
    </Router>
  );
}

export default App;
